import { CashierBiLoggerService } from '@wix/payments-common';

type DefaultParams = {
  appId: string;
  msid: string;
  visitorId: string;
  sessionId: string;
  widgetId: string;
  requestShipping: boolean;
  siteCurrency: boolean;
  checkoutSessionId: string;
};

// Should be used when common event is used in several cases and some fields are not applicable to the case.
// e.g. errorReason for the success event. But we still should define the field to avoid type errors and explicitly
// say via NA that this field is not just missing, forgotten to implement.
export const NA: any = undefined;

export class BiLogger extends CashierBiLoggerService<keyof ReturnType<typeof getDefaultParams>> {
  protected defaultParams?: DefaultParams;

  protected override getDefaultParams() {
    return getDefaultParams(this.defaultParams);
  }

  init = (defaultParams: DefaultParams) => {
    this.defaultParams = defaultParams;
  };
}

function getDefaultParams(defaultParams: DefaultParams) {
  return {
    ...(defaultParams ?? {}),
  } as const;
}
